import React from 'react';
import wrapRoot from './wrap-root';
import wrapPage from './wrap-page';
import { onClientEntry as onClientEntryFunc, onRouteUpdate as onRouteUpdateFunc } from './tracking';

export const wrapRootElement = wrapRoot;
export const wrapPageElement = wrapPage;
export const onClientEntry = onClientEntryFunc;
export const onRouteUpdate = onRouteUpdateFunc;
